import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectConfig } from '../../../../../shared/ui/form/select/select.component.config';
import { Option } from '../../../../../shared/models/option.model';

@Component({
    selector: 'app-contact-debtor-form',
    templateUrl: './contact-debtor-form.component.html',
    styleUrls: ['./contact-debtor-form.component.css'],
    standalone: false
})
export class ContactDebtorFormComponent implements OnInit {
    form!: UntypedFormGroup;

    formConfiguration: any = {
        paymentTypeDebtor: {
            label: 'Forma de cobro por defecto',
            placeholder: 'Selecciona forma de cobro por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        expenseAccountDebtor: {
            label: 'Número cuenta contable de ingreso por defecto',
            placeholder: 'Selecciona número cuenta contable de ingreso por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        paymentDebtorUid: {
            label: 'Número cuenta contable de ingreso por defecto',
            placeholder: 'Selecciona número cuenta contable de ingreso por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        debtorEfectivoId: {
            label: 'Caja/Efectivo',
            placeholder: 'Selecciona Caja/Efectivo',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        debtorPartnersId: {
            label: 'Caja/Efectivo',
            placeholder: 'Selecciona Caja/Efectivo',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        accountNumberDebtor: {
            label: 'Cuenta contable',
            placeholder: ''
        },
        taxDebtorUid: {
            label: 'Impuesto por defecto',
            placeholder: 'Impuesto por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        taxDebtorSecondUid: {
            label: 'Segundo impuesto por defecto',
            placeholder: 'Segundo impuesto por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        expirationDebtor: {
            label: 'Vencimiento de factura por defecto',
            placeholder: 'Introduce vencimiento de factura por defecto'
        }
    }

    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            paymentTypeDebtor: [null, Validators.required],
            paymentDebtorUid: [null, Validators.required],
            debtorEfectivoId: [null, Validators.required],
            debtorPartnersId: [null, Validators.required],
            expenseAccountDebtor: [null, Validators.required],
            accountNumberDebtor: [null, Validators.required],
            taxDebtorUid: [null, Validators.required],
            taxDebtorSecondUid: [null, Validators.required],
            expirationDebtor: [null, Validators.required],
        });
    }

    loadStreetTypes(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    provinciaConfig: SelectConfig = {
        label: 'Provincia',
        placeholder: 'Selecciona provincia',
        multiple: false,
        loadOptions: () => this.loadProvincias()
    };

    municipioConfig: SelectConfig = {
        label: 'Municipio',
        placeholder: 'Selecciona municipio',
        multiple: false,
        loadOptions: () => this.loadMunicipios(this.form.get('provincia')!.value)
    };

    loadProvincias(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    loadMunicipios(provincia: string): Option[] {
        if (provincia === '08') {
            return [
                { value: '08019', label: 'Barcelona' },
                { value: '08101', label: 'L\'Hospitalet' }
            ];
        } else if (provincia === '28') {
            return [
                { value: '28079', label: 'Madrid' },
                { value: '28123', label: 'Getafe' }
            ];
        }
        return [];
    }

    onProvinciaChange(): void {
        const provincia = this.form.get('provincia')!.value;
        this.municipioConfig = {
            ...this.municipioConfig,
            key: Date.now(), // clave única que cambia en cada llamada
            loadOptions: () => this.loadMunicipios(provincia)
        };

        this.form.get('municipio')!.reset();
    }
}
